export enum PaymentMode {
  Portal = 'portal',
  Pay = 'pay',
}
